/* eslint-disable react/no-unknown-property */
import { Head, usePage } from "@inertiajs/react";
import { DefaultPageType } from "types/DefaultPageType";

function escapeHtml(unsafe: string | undefined | null): string {
  if (!unsafe) return '';
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export default function Metadata() {
  const { metadata } = usePage<DefaultPageType>().props;

  return (
    <Head>
      <title>{metadata.title ? `${metadata.title}${metadata.titleTemplate}` : metadata.titleDefault}</title>
      <meta
        head-key="description"
        name="description"
        content={metadata.description}
      />

      <meta property="og:title" head-key="og:title" content={escapeHtml(metadata.openGraph.title)} />
      <meta property="og:description" head-key="og:description" content={escapeHtml(metadata.openGraph.description)} />
      <meta property="og:url" head-key="og:url" content={metadata.openGraph.url} />
      <meta property="og:site_name" head-key="og:site_name" content={metadata.openGraph.siteName} />
      <meta property="og:type" head-key="og:type" content={metadata.openGraph.type} />
      <meta property="og:image" head-key="og:image" content={metadata.openGraph.images[0].url} />
      <meta property="og:image:width" head-key="og:image:width" content={metadata.openGraph.images[0].width} />
      <meta property="og:image:height" head-key="og:image:height" content={metadata.openGraph.images[0].height} />
      <meta property="og:image:alt" head-key="og:image:alt" content={escapeHtml(metadata.openGraph.images[0].alt)} />
      <meta property="og:image:type" head-key="og:image:type" content={metadata.openGraph.images[0].type} />
      {metadata.canonicalUrl && (
        <link rel="canonical" head-key="canonical" href={escapeHtml(metadata.canonicalUrl)} />
      )}

      {Object.keys(metadata.alternates ?? {}).map((type) => (
        <link key={type}
          rel="alternate"
          type={type}
          href={metadata.alternates[type]}
          head-key={`alternate-${type}`}
        />
      ))}
    </Head>
  )
}
